import { Box, Button, Chip, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { AnunciosData } from "../../types/Anuncio/AnuncioData";
import ImagePreviewer from "../../common/Behelit/ImagePreview";
import { useEffect, useState } from "react";
import { Interaccion } from "../../types/Interacciones/Interaccion";
import { FaLink, FaMapMarkedAlt } from "react-icons/fa";
import { BiLike, BiSolidLike } from "react-icons/bi";
import ReceptorService from "../../services/ReceptorService";
import InteraccionServices from "../../services/InteraccionServices";
import { useAppSelector } from "../../redux/hooks";

interface Props {
    anuncio: AnunciosData,
}

export const VerAnuncio: React.FC<Props> = ({ anuncio }) => {
    const [change, setChange] = useState(true);
    const [like, setLike] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuth } = useAppSelector((state) => state.authReducer);
    // funciones
    const cambiarImagen = () => {
        setChange(!change);
    }
    const handleOpenLink = (link: string) => {
        let url = link.trim();

        // Ya viene con https → no tocar
        if (url.startsWith("https://")) {
            window.open(url, "_blank", "noopener,noreferrer");
            return;
        }

        // Viene con http → convertir a https
        if (url.startsWith("http://")) {
            url = "https://" + url.substring(7); // quitar "http://"
            window.open(url, "_blank", "noopener,noreferrer");
            return;
        }

        // Sin protocolo → agregar https automáticamente
        window.open(`https://${url}`, "_blank", "noopener,noreferrer");
    };
    const isValidUrl = (value: string): boolean => {
        try {
            new URL(value);
            return true;
        } catch {
            return false;
        }
    };
    const GetInteraccion = (id: number) => {
        ReceptorService.GetAnunciosInteraccion(id)
            .then((resp) => {
                if (resp.status === 200 && resp.data.bdInteraccion === 1) {
                    setLike(true);
                }
            }).catch((error) => {
                console.error(error);
            })
    }
    const PostInteraccion = () => {
        setIsLoading(true);
        let inter: Interaccion = {
            idAnuncio: anuncio.idAnuncio,
            bdTipo: "L"
        }
        InteraccionServices.PostInteraccion(inter)
            .then((resp) => {
                if (resp.status === 200) {
                    setLike(!like);
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                // Esperar 30 segundos antes de habilitar nuevamente el botón
                setTimeout(() => {
                    setIsLoading(false);
                }, 15000); // 30 segundos en milisegundos
            });
    }
    // Effect
    useEffect(() => {
        GetInteraccion(anuncio.idAnuncio)
    }, [])
    return (
        <Grid container maxWidth="lg" style={{ marginTop: 10, marginLeft: 20, padding: '20px', textAlign: 'center' }} spacing={2}>
            <Grid item sm={12}>
                <Typography variant="h4" gutterBottom>
                    {anuncio.txTitulo}
                </Typography>
            </Grid>
            <Grid item sm={12} md={6}>
                {change ?
                    <ImagePreviewer image={anuncio.txImagen} />
                    : <ImagePreviewer image={anuncio.txtImagenCaratula} />
                }
            </Grid>
            <Grid item sm={12} md={6}>
                <Box>
                    <Grid container style={{ marginTop: 10, marginLeft: 20, padding: '20px', textAlign: 'center' }} spacing={1}>
                        <Grid item sm={12}>
                            <Typography variant="body1" gutterBottom>
                                {anuncio.bdTipo === 'E' ? 'Evento' : 'Anuncio'}
                            </Typography>
                        </Grid>
                        {anuncio.categorias.length > 0 && (
                            <Grid item sm={12}>
                                <Typography variant="body1" gutterBottom>
                                    Categorías:
                                </Typography>
                                {anuncio.categorias.map((cat, index) => (
                                    <Chip label={cat.txNombreCategoria} color="primary" />
                                ))}
                            </Grid>
                        )}
                        {anuncio.bdTipo === 'E' && (
                            <Grid item sm={12}>
                                <Typography variant="body1" gutterBottom>
                                    {anuncio.nombreTipoEvento}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item sm={12}>
                            <Typography variant="body1" gutterBottom>
                                Ámbito: {anuncio.bdAmbito === 'A' ? 'Público general' : 'Comunidad Politécnica'}
                            </Typography>
                        </Grid>
                        <Grid item sm={12}>
                            <Typography variant="body1" gutterBottom>
                                Descripción:
                            </Typography>
                        </Grid>
                        <Grid item sm={12}>
                            <Typography variant="body1" gutterBottom>
                                {anuncio.txTexto}
                            </Typography>
                        </Grid>
                        {isAuth ?
                            <Grid item sm={12} md={4}>
                                <Tooltip title={'like'} placement="top">
                                    <IconButton aria-label="delete" color="primary" onClick={() => PostInteraccion()} disabled={isLoading}>
                                        {!like ? <BiLike /> : <BiSolidLike />}
                                    </IconButton>
                                </Tooltip>
                            </Grid> : <></>
                        }
                        <Grid item sm={12} md={4}>
                            {isValidUrl(anuncio.txUrl) ?
                                <Tooltip title={'enlace'} placement="top">
                                    <IconButton aria-label="delete" color="primary" onClick={() => handleOpenLink(anuncio.txUrl)} >
                                        <FaLink />
                                    </IconButton>
                                </Tooltip>
                                :
                                <></>
                            }
                        </Grid>
                        <Grid item sm={12} md={4}>
                            {anuncio.txtUrlMaps !== null && anuncio.txtUrlMaps !== '' ?
                                <Tooltip title={'Google Maps'} placement="top">
                                    <IconButton aria-label="delete" color="primary" onClick={() => handleOpenLink(anuncio.txtUrlMaps)}>
                                        <FaMapMarkedAlt />
                                    </IconButton>
                                </Tooltip>
                                : <></>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            {/* <Grid item sm={12} md={6}>
                {anuncio.bdTipo === 'E' && (
                    <Button variant="contained" onClick={cambiarImagen}>
                        {change ? 'Carátula' : 'Imagen'}
                    </Button>)
                }
            </Grid> */}
        </Grid>
    );
}